// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"menu-item-module--menuItem--hDXWT","menuLink":"menu-item-module--menuLink--1QX9i"};